document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 767) {
        const cards = document.querySelectorAll(".card-link");
        let activeCard: Element | null = null;
        console.log("test");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // If a new card is fully in view, deactivate the old active card
                        if (activeCard) {
                            activeCard.classList.remove("active");
                        }

                        // Activate the new card and update the activeCard reference
                        entry.target.classList.add("active");
                        activeCard = entry.target;
                    }
                });
            },
            {
                threshold: 1.0,
            }
        );

        cards.forEach((card) => {
            observer.observe(card);
        });
    }
});
